import { Skeleton, Spin } from "antd";
import { FC } from "react";

interface SpinalProps {
  initializing: boolean;
  loading: boolean;
  children?: React.ReactNode;
}

export const Spinal: FC<SpinalProps> = ({
  children,
  initializing,
  loading,
}) => {
  return (
    <Skeleton active loading={initializing}>
      <Spin spinning={loading}>{children}</Spin>
    </Skeleton>
  );
};
